import { render, staticRenderFns } from "./FacilitiesSettings.vue?vue&type=template&id=2ca91183&scoped=true"
import script from "./FacilitiesSettings.vue?vue&type=script&lang=js"
export * from "./FacilitiesSettings.vue?vue&type=script&lang=js"
import style0 from "./FacilitiesSettings.vue?vue&type=style&index=0&id=2ca91183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca91183",
  null
  
)

export default component.exports